import { dfpConfig } from '../../../../Settings/global.json';
import { DeviceHelper } from '../../Core/DeviceHelper';

export function GetConfig() {
    const device = DeviceHelper.GetDevice();

    let config = Object.assign(
        dfpConfig.config,
        dfpConfig.deviceConfig[device]);
    return config;
}






// WEBPACK FOOTER //
// ./Statics/scripts/Modules/DFP/DFPConfigProvider.js